export default "__VITE_ASSET__o_W9kMNO__"